import * as React from 'react'
import Box from '@mui/material/Box'
import Container from '@mui/material/Container'

import CentralDivider from 'src/components/atoms/CentralDivider'
import CompanyTitleContrast from 'src/components/atoms/CompanyTitleContrast'
import CircleWithChevron from 'src/components/atoms/CircleWithChevron'

interface Props {
  children: React.ReactNode
}

const TimelineSection = ({children}: Props) => (
  <Container
    component="section"
    maxWidth="lg"
    sx={{
      py: 10,
      position: 'relative',
    }}
  >
    <CompanyTitleContrast title="Journey" />
    <Box
      sx={{
        position: 'sticky',
        top: 0,
        zIndex: -1,
        display: {xs: 'none', md: 'block'},
      }}
    >
      <Box
        sx={{
          position: 'relative',
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, 25vh)',
          width: '13%',
        }}
      >
        <CircleWithChevron />
      </Box>
      <Box
        sx={{
          position: 'relative',
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, 50vh)',
          width: '13%',
          height: 30,
        }}
      >
        <CircleWithChevron />
      </Box>
    </Box>
    <CentralDivider />
    <Box sx={{display: 'flex', flexDirection: 'column', pt: {md: 6, xs: 2}}}>
      {children}
    </Box>
  </Container>
)

export default TimelineSection
